/* eslint-disable @typescript-eslint/default-param-last */
/* eslint no-param-reassign: ["error", { "props": false }] */
import produce, { Draft } from 'immer';
import { RESET_LOCAL_ACCOUNTS, SET_LOCAL_ACCOUNTS } from '../actions/userAccountAction';
import { AccountSchema } from '../requests/api/apiTypes';
import {
  LocalAccountsCustomAction, LocalAccountsState,
} from '../types';

const initialState: LocalAccountsState = {
  localAccounts: [],
};

const localAccountReducer = (
  state = initialState,
  action: LocalAccountsCustomAction,
): LocalAccountsState => {
  switch (action.type) {
    case SET_LOCAL_ACCOUNTS: {
      return produce(state, (draft: Draft<LocalAccountsState>) => {
        draft.localAccounts = action.payload as AccountSchema[];
      });
    }

    case RESET_LOCAL_ACCOUNTS: {
      return produce(state, (draft: Draft<LocalAccountsState>) => {
        draft.localAccounts = [];
      });
    }

    default: {
      return state;
    }
  }
};

export default localAccountReducer;
